/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/store/store.module';
import * as i2 from './store/store.component.ngfactory';
import * as i3 from './categories/categories.component.ngfactory';
import * as i4 from './product/product.component.ngfactory';
import * as i5 from './popular/popular.component.ngfactory';
import * as i6 from './products/products.component.ngfactory';
import * as i7 from './browser/browser.component.ngfactory';
import * as i8 from './item/item.component.ngfactory';
import * as i9 from './items/items.component.ngfactory';
import * as i10 from './checkout/checkout.component.ngfactory';
import * as i11 from './checkout/thankyou/checkout.thankyou.ngfactory';
import * as i12 from './customize/customize.component.ngfactory';
import * as i13 from '@angular/common';
import * as i14 from '@angular/platform-browser';
import * as i15 from '@angular/forms';
import * as i16 from 'angular2-recaptcha/lib/captcha.service';
import * as i17 from 'ngx-window-token/dist/src/ngx-window-token';
import * as i18 from 'ngx-clipboard/src/clipboard.service';
import * as i19 from '../../../app/services/user.service';
import * as i20 from '@angular/http';
import * as i21 from 'ngx-cookie/src/cookie.service';
import * as i22 from 'angulartics2/dist/core/angulartics2';
import * as i23 from '../../../app/services/store.service';
import * as i24 from 'ng-select';
import * as i25 from '../../../app/app.pipes';
import * as i26 from 'angular2-recaptcha/angular2-recaptcha';
import * as i27 from 'ngx-clipboard/src/index';
import * as i28 from '@angular/router';
import * as i29 from '../../../app/store/store/store.component';
import * as i30 from '../../../app/store/categories/categories.component';
import * as i31 from '../../../app/store/product/product.component';
import * as i32 from '../../../app/store/popular/popular.component';
import * as i33 from '../../../app/store/products/products.component';
import * as i34 from '../../../app/store/browser/browser.component';
import * as i35 from '../../../app/store/item/item.component';
import * as i36 from '../../../app/store/items/items.component';
import * as i37 from '../../../app/store/checkout/checkout.component';
import * as i38 from '../../../app/store/checkout/thankyou/checkout.thankyou';
import * as i39 from '../../../app/store/customize/customize.component';
export const StoreModuleNgFactory:i0.NgModuleFactory<i1.StoreModule> = i0.ɵcmf(i1.StoreModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.StoreComponentNgFactory,i3.CategoryComponentNgFactory,i4.ProductComponentNgFactory,
              i5.PopularComponentNgFactory,i6.ProductsComponentNgFactory,i7.BrowserComponentNgFactory,
              i8.ItemComponentNgFactory,i9.ItemsComponentNgFactory,i10.CheckoutComponentNgFactory,
              i11.CheckoutThankyouComponentNgFactory,i12.CustomizeComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i13.NgLocalization,i13.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(4608,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(5120,
          i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,([] as any[])),
          i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),i0.ɵmpd(4608,i14.DomSanitizer,
              i14.ɵe,[i13.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i14.DomSanitizer]),
          i0.ɵmpd(4608,i14.HAMMER_GESTURE_CONFIG,i14.HammerGestureConfig,([] as any[])),
          i0.ɵmpd(5120,i14.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i14.ɵDomEventsPlugin(p0_0),new i14.ɵKeyEventsPlugin(p1_0),
                new i14.ɵHammerGesturesPlugin(p2_0,p2_1)];
          },[i13.DOCUMENT,i13.DOCUMENT,i13.DOCUMENT,i14.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i14.EventManager,i14.EventManager,[i14.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i14.ɵDomSharedStylesHost,i14.ɵDomSharedStylesHost,[i13.DOCUMENT]),
          i0.ɵmpd(4608,i14.ɵDomRendererFactory2,i14.ɵDomRendererFactory2,[i14.EventManager,
              i14.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i14.ɵDomRendererFactory2]),i0.ɵmpd(6144,i14.ɵSharedStylesHost,(null as any),
              [i14.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i14.Meta,i14.Meta,[i13.DOCUMENT]),i0.ɵmpd(4608,
              i14.Title,i14.Title,[i13.DOCUMENT]),i0.ɵmpd(4608,i15.ɵi,i15.ɵi,([] as any[])),
          i0.ɵmpd(5120,i16.ReCaptchaService,i16.RECAPTCHA_SERVICE_PROVIDER_FACTORY,
              [i0.NgZone,[3,i16.ReCaptchaService]]),i0.ɵmpd(5120,i17.WINDOW,i17._window,
              ([] as any[])),i0.ɵmpd(5120,i18.ClipboardService,i18.CLIPBOARD_SERVICE_PROVIDER_FACTORY,
              [i14.DOCUMENT,i17.WINDOW,[3,i18.ClipboardService]]),i0.ɵmpd(4608,i19.UserService,
              i19.UserService,[i20.Http,i21.CookieService,i22.Angulartics2]),i0.ɵmpd(4608,
              i23.StoreService,i23.StoreService,[i20.Http,i21.CookieService,i19.UserService,
                  i22.Angulartics2]),i0.ɵmpd(512,i13.CommonModule,i13.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i14.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any) => {
                return [i14.ɵc(p0_0,p0_1)];
              },[[2,i14.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i14.BrowserModule,i14.BrowserModule,[[3,i14.BrowserModule]]),
          i0.ɵmpd(512,i15.ɵba,i15.ɵba,([] as any[])),i0.ɵmpd(512,i15.FormsModule,i15.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i24.SelectModule,i24.SelectModule,([] as any[])),
          i0.ɵmpd(512,i25.MainPipeModule,i25.MainPipeModule,([] as any[])),i0.ɵmpd(512,
              i26.ReCaptchaModule,i26.ReCaptchaModule,([] as any[])),i0.ɵmpd(512,i17.WindowTokenModule,
              i17.WindowTokenModule,([] as any[])),i0.ɵmpd(512,i27.ClipboardModule,
              i27.ClipboardModule,([] as any[])),i0.ɵmpd(512,i28.RouterModule,i28.RouterModule,
              [[2,i28.ɵa],[2,i28.Router]]),i0.ɵmpd(512,i1.StoreModule,i1.StoreModule,
              ([] as any[])),i0.ɵmpd(1024,i28.ROUTES,() => {
            return [[{path:'shop',component:i29.StoreComponent,data:{title:'Shop Identity RPG'}},
                {path:'store',component:i29.StoreComponent,data:{title:'Shop Identity RPG'}},
                {path:'categories',component:i30.CategoryComponent,data:{title:'Identity RPG | Shop by Category'}},
                {path:'shop/categories',component:i30.CategoryComponent,data:{title:'Identity RPG | Shop by Category'}},
                {path:'shop/category/:id',component:i30.CategoryComponent,data:{title:'Identity RPG | Shop by Category'}},
                {path:'shop/categories/:id',component:i30.CategoryComponent,data:{title:'Identity RPG | Shop by Category'}},
                {path:'shop/product/:id',component:i31.ProductComponent,data:{title:'Identity RPG | Online Shop'}},
                {path:'shop/popular',component:i32.PopularComponent,data:{title:'Identity RPG | Popular Items'}},
                {path:'product/:id',component:i31.ProductComponent,data:{title:'Identity RPG | Online Shop'}},
                {path:'shop/products',component:i33.ProductsComponent,data:{title:'Identity RPG | Products'}},
                {path:'products',component:i33.ProductsComponent,data:{title:'Identity RPG | Products'}},
                {path:'browse',component:i34.BrowserComponent,data:{title:'Identity RPG | Shop Categories'}},
                {path:'shop/browse',component:i34.BrowserComponent,data:{title:'Identity RPG | Shop Categories'}},
                {path:'browser',component:i34.BrowserComponent,data:{title:'Identity RPG | Shop Categories'}},
                {path:'popular',component:i32.PopularComponent,data:{title:'Identity RPG | Popular Items'}},
                {path:'shop/item/:id',component:i35.ItemComponent,data:{title:'Game Item | Identity RPG'}},
                {path:'item/:id',component:i35.ItemComponent,data:{title:'Game Item | Identity RPG'}},
                {path:'items',component:i36.ItemsComponent,data:{title:'Identity RPG | Items'}},
                {path:'checkout',component:i37.CheckoutComponent,data:{title:'Checkout | Identity RPG'}},
                {path:'shop/items',component:i36.ItemsComponent,data:{title:'Identity RPG | Items'}},
                {path:'shop/checkout',component:i37.CheckoutComponent,data:{title:'Checkout | Identity RPG'}},
                {path:'shop/thankyou',component:i38.CheckoutThankyouComponent,data:{title:'Checkout | Identity RPG'}},
                {path:'thankyou',component:i38.CheckoutThankyouComponent,data:{title:'Thank you! | Identity RPG'}},
                {path:'customize',component:i39.CustomizeComponent,data:{title:'Build your Identity - Identity Online RPG'}}]];
          },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC9zdG9yZS9zdG9yZS5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC9zdG9yZS9zdG9yZS5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/app/store/store.module.ngfactory.ts